// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"770":"fc44f5a81ff2aaa68163","951":"36ba1fe792a15c647d57"}[chunkId] + ".js";
};